import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import { doToast } from '../../../utils'
import { toast } from 'react-toastify'
import { doRequestGet } from '../../../api'

const CouponForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_coupon: '',
    p_name_coupon: '',
    p_enabled_coupon: 0,
    p_type_coupon: '',
    p_key_coupon: '',
    p_amount_coupon: '',
    p_qty_coupon: '',
    p_limit_coupon: '',
    p_id_event: '',
  })
  const [ready, setReady] = useState(false);
  const [typeCoupon] = useState([
    { id_type_coupon: 'PERCENTAGE', name_type_coupon: 'Porcentaje', enabled_type_coupon: 1 },
    { id_type_coupon: 'AMOUNT', name_type_coupon: 'Monto', enabled_type_coupon: 1 },
  ])
  const [events, setEvents] = useState([])

  const dataSubmit = useMemo(() => {
    return row;
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/coupon',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/coupon/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getEvents = await doRequestGet({
            url: '/event'
          })
          setEvents(getEvents.data);

          if (rowId) {
            setRow({
              p_id_coupon: getRow.id_coupon,
              p_name_coupon: getRow.name_coupon,
              p_amount_coupon: getRow.amount_coupon,
              p_key_coupon: getRow.key_coupon,
              p_type_coupon: getRow.type_coupon,
              p_enabled_coupon: getRow.enabled_coupon,
              p_qty_coupon: getRow.qty_coupon,
              p_limit_coupon: getRow.limit_coupon,
              p_id_event: getRow.id_event,
            })
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_type_coupon) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un tipo de cupón.',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <SelectCustom
        valueId={row.p_id_event}
        keyName="event"
        options={events}
        setRow={setRow}
        row={row}
        selectText="Evento"
        selectPops={{
          classNameParent: 'col-md-12 mb-2',
        }}
      />
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_coupon}
        onChange={e => setRow({ ...row, p_name_coupon: e.target.value })}
        maxLength={255}
      />
      <Input
        text="Clave"
        placeholder="Clave"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_key_coupon}
        onChange={e => {
          if (rowId === '') {
            setRow({ ...row, p_key_coupon: e.target.value.toUpperCase() })
          }
        }}
        maxLength={255}
        disabled={rowId !== ''}
      />
      <SelectCustom
        valueId={row.p_type_coupon}
        keyName="type_coupon"
        options={typeCoupon}
        setRow={setRow}
        row={row}
        selectText="Tipo de Cupón"
        selectPops={{
          classNameParent: 'col-md-12 mb-3',
        }}
        keyIsString
        onChangeKey="p_type_coupon"
      />
      <Input
        text="Monto"
        placeholder="Monto"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_amount_coupon}
        onChange={e => setRow({ ...row, p_amount_coupon: e.target.value })}
        maxLength={255}
        type="number"
        step="0.01"
        min="0"
      />
      <SwitchToggle
        id="coupon-limit"
        textCheck="Desactivar Stock"
        textUnChecked="Activar Stock"
        classNameParent="col-12 mb-3"
        checked={row.p_limit_coupon === 'CANTIDAD'}
        onChange={e => setRow({ ...row, p_limit_coupon: e.target.checked ? 'CANTIDAD' : '', p_qty_coupon: '' })}
      />
      {row.p_limit_coupon === 'CANTIDAD' && <Input
        text="Stock"
        placeholder="Stock"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_qty_coupon}
        onChange={e => setRow({ ...row, p_qty_coupon: e.target.value })}
        maxLength={255}
        type="number"
        step="1"
        min="0"
      />}
      <SwitchToggle
        id="coupon-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_coupon === 1}
        onChange={e => setRow({ ...row, p_enabled_coupon: e.target.checked ? 1 : 0 })}
      />
    </FormCustom>
  </ReactPlaceholder>
}

CouponForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  CouponForm
};